// Exact accessibility patterns from legacy App.jsx
import { useCallback, useEffect } from 'react';

export const useAccessibility = (
  isPromptGalleryOpen: boolean,
  setIsPromptGalleryOpen: (open: boolean) => void,
  clearConversation: () => void
) => {
  // Legacy pattern: handleKeyDown function (exact copy from App.jsx)
  const handleKeyDown = useCallback((event: React.KeyboardEvent, purpose: string) => {
    if (event.key === "Enter") {
      switch (purpose) {
        case "ToggleAudio":
          // Not applicable in current copilot
          break;
        case "ExpandCollapse":
          // Not applicable in current copilot  
          break;
        case "Refresh":
          clearConversation();
          break;
        case "Close":
          // Not applicable in current copilot
          break;
        case "PromptGallery":
          setIsPromptGalleryOpen(!isPromptGalleryOpen);
          break;
        default:
          break;
      }
    }
  }, [isPromptGalleryOpen, setIsPromptGalleryOpen, clearConversation]);

  // Legacy pattern: Global keyboard event handler for Escape key
  useEffect(() => {
    const handleGlobalKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' && isPromptGalleryOpen) {
        setIsPromptGalleryOpen(false);
        event.preventDefault();
      }
    };

    if (isPromptGalleryOpen) {
      window.addEventListener('keydown', handleGlobalKeyDown);
      return () => window.removeEventListener('keydown', handleGlobalKeyDown);
    }
    
    return () => {}; // Empty cleanup function for when modal is not open
  }, [isPromptGalleryOpen, setIsPromptGalleryOpen]);

  return {
    handleKeyDown
  };
};